import { useContext } from 'react';

import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import CustomerLinkCell from '../../../components/Table/TableAccessories/CustomerLinkCell';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import { TableContext } from '../../../components/Table/TableContext';
import { GIFT_STATUS_OPTIONS } from '../../../models/gifts/gift.model';
import { capitalize, formatNaira } from '../../../utils/utils';
import GiftDetailSlider from './GiftDetailSlider';

const Gifts = () => (
  <Page title='Hethera | Dash gifts'>
    <PageLayout>
      <PageHeader title='Dash gifts' className='no-bottom-padding' />

      <Table
        tableHeader={{
          Code: 'code',
          From: 'sender_chat_id',
          To: 'recipient_chat_id',
          Gift: 'bill_type',
          'Sender paid': 'amount',
          Status: 'status',
          Refund: 'refund_status',
          'Delivery day': 'deliver_at',
          Created: 'created_at',
        }}
        tableDataSourceUrl='api/v1/admin/gifts'
        size={20}
        border
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search by code or phone number',
          rightAttr: [{ type: 'custom-filter', comp: <StatusFilter /> }],
        }}
        cellsCustomComp={{
          sender_chat_id: <CustomerLinkCell dataKey='sender_chat_id' />,
          recipient_chat_id: <CustomerLinkCell dataKey='recipient_chat_id' />,
          bill_type: <GiftCell />,
          amount: <PaidCell />,
          status: <StatusCell statusKey='status' hasDot />,
          refund_status: <StatusCell statusKey='refund_status' />,
          deliver_at: <TableDateTimeFormatter dataKey='deliver_at' />,
          created_at: <TableDateTimeFormatter dataKey='created_at' />,
        }}
        clickRowShowSliderComp={(row) => <GiftDetailSlider data={row as any} />}
        hasClickableRow
        emptyStateMsg='No gifts found'
      />
    </PageLayout>
  </Page>
);

export default Gifts;

const GiftCell: React.FC<{ data?: Record<string, any> }> = ({ data }) => (
  <>{data?.bill_type ? `${capitalize(data.bill_type.toLowerCase())} ${formatNaira(Number(data.amount ?? 0))}` : '—'}</>
);

// What the sender's card was charged: the gift plus the fee.
const PaidCell: React.FC<{ data?: Record<string, any> }> = ({ data }) => (
  <>{data?.amount ? formatNaira(Number(data.amount) + Number(data.fee ?? 0)) : '—'}</>
);

const StatusFilter = () => {
  const tableContext = useContext(TableContext);
  return (
    <Select
      defaultValue=''
      aria-label='Filter by status'
      onChange={(e) => tableContext?.handleSetTableFilterRecord({ status: e.target.value, page: 0 })}
    >
      <option value=''>All statuses</option>
      {GIFT_STATUS_OPTIONS.map((status) => (
        <option key={status} value={status}>
          {capitalize(status.replace(/_/g, ' ').toLowerCase())}
        </option>
      ))}
    </Select>
  );
};

const Select = styled.select`
  border: 1px solid #E2DED3;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  color: #0E1A13;
  background-color: white;
`;
